const crypto = require('crypto');
export {
    PBKDF2
  }
/**
 * PBKDF2加密
 * @param {*} data 需要加密的数据
 * @returns 
 */
const PBKDF2 = (data) => {
    const key = crypto.pbkdf2Sync(data, 'adiffcultsaltocheckkjqkwlrjqklweqjkweljqkeljqwk', 1000, 64, 'sha512');
    return key.toString('hex');
}